import { useMutation, useQueryClient } from '@tanstack/react-query';

import { removeEmployee } from '@entities/myTeam/api/removeEmployee';
import { reloadPage } from '@shared/helpers';

export const useDeleteEmployee = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ['deleteEmployee'],
        mutationFn: removeEmployee,
        onSuccess: (res) => {
            if (typeof res === 'string') {
                console.warn('Mutation returned error as string — skip invalidation');
                reloadPage();
                return;
            }
            queryClient.invalidateQueries({ queryKey: ['myTeam'] });
        },
    });
};
